<template>
  <div class="drawer">
    <el-drawer
      size="800px"
      title="新建预约"
      :visible.sync="drawerStatus"
      @close="handleClose"
    >
      <div class="page">
        <div
          style="
            width: 100%;
            height: 1px;
            background: #f2f2f2;
            margin-top: -30px;
            margin-bottom: 10px;
          "
        ></div>
        <div>
          <!-- 1 洗美 2 医疗 3 寄养 4 看宠 -->
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="洗美预约" name="1"></el-tab-pane>
            <el-tab-pane label="看宠预约" name="4"></el-tab-pane>
            <el-tab-pane label="寄养预约" name="3"></el-tab-pane>
            <el-tab-pane label="医疗预约" name="2"></el-tab-pane>
          </el-tabs>
          <!-- 洗美 -->
          <div v-show="activeName == '1'">
            <div>
              <el-form :model="createBath" label-width="80px">
                <el-form-item label="预约用户:">
                  <el-select
                    class="selectKeyword"
                    v-model="userId"
                    placeholder="请输入顾客手机号"
                    filterable
                    remote
                    clearable
                    @blur="changeMember"
                    @change="changeMember"
                    :remote-method="remoteMethodMember"
                  >
                    <el-option
                      v-for="item in vipList"
                      :key="item._id"
                      :label="
                        (!item.club_card || item.club_card. surplus_day == 0
                          ? ''
                          : '[' + item.club_card. surplus_day + '星]') +
                        item.basic_info.nick_name +
                        (item.basic_info.user_mobile
                          ? ' (' + item.basic_info.user_mobile + ')'
                          : '(无手机号)')
                      "
                      :value="item._id"
                    >
                    </el-option>
                    <template slot="empty">
                      <div
                        style="
                          width: 300px;
                          font-size: 14px;
                          color: red;
                          text-align: center;
                          padding: 10px 0;
                        "
                      >
                        没有客户信息，请创建客户档案
                      </div>
                    </template>
                  </el-select>
                </el-form-item>
                <el-form-item label="预约宠物:">
                  <el-select
                    v-model="createBath.petId"
                    placeholder="请选择宠物"
                    clearable
                    @visible-change="changePet($event)"
                  >
                    <el-option
                      v-for="item in petsList"
                      :key="item._id"
                      :label="item.nick_name"
                      :value="item._id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="预约备注:">
                  <el-input
                    type="textarea"
                    v-model="createBath.remark"
                  ></el-input>
                </el-form-item>
                <el-form-item label="预约日期:">
                  <el-select
                    v-model="createBath.reserveDate"
                    placeholder="请选择"
                    @change="changeBathDate"
                  >
                    <el-option
                      v-for="item in days"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="洗美人员:">
                  <el-select
                    v-model="createBath.staffId"
                    placeholder="请选择"
                    @change="changeBathStaff"
                  >
                    <el-option
                      v-for="item in staffList"
                      :key="item.id"
                      :label="item.staffName"
                      :value="item.staffId"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="洗美时间:">
                  <el-select
                    v-model="createBath.times"
                    multiple
                    @visible-change="changeTime($event)"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in timeUseList"
                      :key="item.id"
                      :disabled="item.canState !== 1"
                      :label="
                        parseInt(item.time) == item.time
                          ? item.time + ':00'
                          : parseInt(item.time) + ':30'
                      "
                      :value="item.time"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="洗美项目:">
                  <div>洗澡</div>
                  <div>
                    <el-select
                      @blur="changeConfig"
                      clearable
                      filterable
                      :disabled="configStateXz"
                      @change="changeConfig"
                      v-model="createBath.xzProjectId"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in xzProjects"
                        :key="item.id"
                        :label="item.projectName"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                  <div>美容</div>
                  <div>
                    <el-select
                    clearable
                    filterable
                    :disabled="configState"
                    @change="changeConfig"
                      @blur="changeConfig"
                      v-model="createBath.mrProjectId"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in mrProjects"
                        :key="item.id"
                        :label="item.projectName"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                  <div>单项服务</div>
                  <div>
                    <el-select
                      clearable
                      multiple
                      filterable
                      v-model="createBath.dxProjectId"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in dxProjects"
                        :key="item.id"
                        :label="item.projectName"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <!-- 看宠 -->
          <div v-show="activeName == '4'">
            <div>
              <el-form :model="seePet" label-width="80px">
                <el-form-item label="预约用户:">
                  <el-select
                    class="selectKeyword"
                    v-model="userId"
                    placeholder="请输入顾客手机号"
                    filterable
                    remote
                    :remote-method="remoteMethodMember"
                  >
                    <!-- <el-option
                      v-for="item in vipList"
                      :key="item._id"
                      :label="
                        (!item.club_card || item.club_card. surplus_day == 0
                          ? ''
                          : '[' + item.club_card. surplus_day + '星]') +
                        item.basic_info.nick_name +
                        (item.basic_info.user_mobile
                          ? ' (' + item.basic_info.user_mobile + ')'
                          : '(无手机号)')
                      "
                      :value="item._id"
                    >
                    </el-option> -->
                    <template slot="empty">
                      <div
                        style="
                          width: 300px;
                          font-size: 14px;
                          color: red;
                          text-align: center;
                          padding: 10px 0;
                        "
                      >
                        没有客户信息，请创建客户档案
                      </div>
                    </template>
                  </el-select>
                </el-form-item>
                <el-form-item label="意向宠物:">
                  <el-radio-group
                    v-model="seePet.petType"
                    @input="changeSeePet"
                  >
                    <el-radio :label="1">猫咪</el-radio>
                    <el-radio :label="2">狗狗</el-radio>
                    <el-radio :label="3">未知</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="宠物品种:" v-show="seePet.seeShow">
                  <el-select v-model="seePet.petClassId" placeholder="请选择">
                    <el-option
                      v-for="item in petTypeList"
                      :key="item._id"
                      :label="item.name"
                      :value="item._id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="预约备注:">
                  <el-input type="textarea" v-model="seePet.remark"></el-input>
                </el-form-item>
                <el-form-item label="预约日期:">
                  <el-select v-model="seePet.reserveDate" placeholder="请选择">
                    <el-option
                      v-for="item in days"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="预约时间:">
                  <div>
                    <el-time-select
                      style="width: 40%; margin-bottom: 10px"
                      v-model="seePet.time"
                      :picker-options="{
                        start: '08:00',
                        step: '00:60',
                        end: '22:00',
                      }"
                      value-format="HH:mm"
                      format="HH:mm"
                      placeholder="请选择预约时间"
                    >
                    </el-time-select>
                  </div>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <!-- 医疗 -->
          <div v-show="activeName == '2'">
            <div>
              <el-form :model="createMedical" label-width="80px">
                <el-form-item label="意向项目:">
                  <el-select v-model="createMedical.id" placeholder="请选择">
                    <el-option
                      v-for="item in medicalProList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="预约用户:">
                  <el-select
                    class="selectKeyword"
                    v-model="userId"
                    placeholder="请输入顾客手机号"
                    filterable
                    remote
                    clearable
                    @blur="changeMember"
                    @change="changeMember"
                    :remote-method="remoteMethodMember"
                  >
                    <!-- <el-option
                      v-for="item in vipList"
                      :key="item._id"
                      :label="
                        (!item.club_card || item.club_card. surplus_day == 0
                          ? ''
                          : '[' + item.club_card. surplus_day + '星]') +
                        item.basic_info.nick_name +
                        (item.basic_info.user_mobile
                          ? ' (' + item.basic_info.user_mobile + ')'
                          : '(无手机号)')
                      "
                      :value="item._id"
                    >
                    </el-option> -->
                    <template slot="empty">
                      <div
                        style="
                          width: 300px;
                          font-size: 14px;
                          color: red;
                          text-align: center;
                          padding: 10px 0;
                        "
                      >
                        没有客户信息，请创建客户档案
                      </div>
                    </template>
                  </el-select>
                </el-form-item>
                <el-form-item label="预约宠物:">
                  <el-select v-model="createMedical.petId" placeholder="请选择">
                    <el-option
                      v-for="item in petsList"
                      :key="item._id"
                      :label="item.nick_name"
                      :value="item._id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="预约备注:">
                  <el-input
                    type="textarea"
                    v-model="createMedical.remark"
                  ></el-input>
                </el-form-item>
                <el-form-item label="预约日期:">
                  <!-- days -->
                  <el-select
                    v-model="createMedical.reserveDate"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in days"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="预约时间:">
                  <div>
                    <el-time-select
                      style="width: 40%; margin-bottom: 10px"
                      v-model="createMedical.time"
                      :picker-options="{
                        start: '08:00',
                        step: '00:60',
                        end: '22:00',
                      }"
                      value-format="HH:mm"
                      format="HH:mm"
                      placeholder="请选择预约时间"
                    >
                    </el-time-select>
                  </div>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <!-- 寄养 -->
          <div v-show="activeName == '3'">
            <div>
              <el-form :model="createFoster" label-width="80px">
                <el-form-item label="预约用户:">
                  <el-select
                    class="selectKeyword"
                    v-model="userId"
                    placeholder="请输入顾客手机号"
                    filterable
                    remote
                    clearable
                    @blur="changeMember"
                    @change="changeMember"
                    :remote-method="remoteMethodMember"
                  >
                    <!-- <el-option
                      v-for="item in vipList"
                      :key="item._id"
                      :label="
                        (!item.club_card || item.club_card. surplus_day == 0
                          ? ''
                          : '[' + item.club_card. surplus_day + '星]') +
                        item.basic_info.nick_name +
                        (item.basic_info.user_mobile
                          ? ' (' + item.basic_info.user_mobile + ')'
                          : '(无手机号)')
                      "
                      :value="item._id"
                    >
                    </el-option> -->
                    <template slot="empty">
                      <div
                        style="
                          width: 300px;
                          font-size: 14px;
                          color: red;
                          text-align: center;
                          padding: 10px 0;
                        "
                      >
                        没有客户信息，请创建客户档案
                      </div>
                    </template>
                  </el-select>
                </el-form-item>
                <el-form-item label="预约宠物:">
                  <el-select
                    v-model="createFoster.petIds"
                    placeholder="请选择"
                    multiple
                  >
                    <el-option
                      v-for="item in petsList"
                      :key="item._id"
                      :label="item.nick_name"
                      :value="item._id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="预约备注:">
                  <el-input
                    type="textarea"
                    v-model="createFoster.remark"
                  ></el-input>
                </el-form-item>
                <el-form-item label="预约日期:">
                  <el-select
                    v-model="createFoster.reserveDate"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in days"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="预约时间:">
                  <el-time-select
                    style="width: 40%; margin-bottom: 10px"
                    v-model="createFoster.time"
                    :picker-options="{
                      start: '08:00',
                      step: '00:60',
                      end: '22:00',
                    }"
                    value-format="HH:mm"
                    format="HH:mm"
                    placeholder="请选择预约时间"
                  >
                  </el-time-select>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </div>
      <div style="height: 40px; width: 100%"></div>
      <div class="btnBox">
        <div class="btnItem" @click="drawerStatus = false">取消</div>
        <div class="btnItem submit" @click="submit">确定</div>
      </div>
    </el-drawer>
  </div>
</template>
<!-- // 1 洗美 2 医疗 3 寄养 4 看宠 -->

<script>
export default {
  data() {
    return {
      configStateXz:false,
      configState: false,
      activeName: "1",
      linkmanName: "",
      linkmanMobile: "",
      userId: "",
      keyword: "",
      vipList: [], //会员信息
      petsList: [], //宠物列表
      days: [], //时间列表
      staffList: [], //洗美人员列表
      timeUseList: [
        {
          time: "",
        },
      ], //洗美人员的时间列表
      dxProjects: [],
      mrProjects: [],
      xzProjects: [],
      staffNum: "",
      //洗美预约 用户的宠物类型
      petClass: "",
      projects: [], //洗澡项目集合
      maxdays: 7,
      drawerStatus: false,
      petTypeList: [], //宠物品种列表
      direction: "rtl",

      // 洗美预约
      createBath: {
        userId: "",
        petId: "",
        remark: "",
        reserveDate: "",
        staffId: "", //员工id
        times: [],
        time: "",
        xzProjectId: "",
        mrProjectId: "",
        dxProjectId: [],
      },
      // 看宠预约
      seePet: {
        petType: 1,
        petClassId: "",
        remark: "",
        seeShow: true,
        time: "",
        petTypeObj: null,
        petClass: {
          name: "",
          id: "",
        },
      },
      seePetTypeList: [
        {
          id: "1",
          name: "猫",
          code: "1",
        },
        {
          id: "2",
          name: "狗",
          code: "2",
        },
        {
          id: "3",
          name: "未知",
          code: "3",
        },
      ],
      // 医疗预约
      createMedical: {
        id: "",
        petId: "",
        remark: "",
        reserveDate: "",
        time: "",
      },
      medicalPro: null,
      medicalProList: [
        { id: "1", name: "疫苗" },
        { id: "2", name: "驱虫" },
        { id: "3", name: "看宠" },
        { id: "4", name: "体检" },
        { id: "5", name: "绝育" },
        { id: "6", name: "挂号" },
      ],
      // 寄养预约
      createFoster: {
        userId: "",
        petIds: [],
        remark: "",
        reserveDate: "",
        time: "",
      },

      value: "",
      // 洗美提交的宠物信息
      reservePetInfo: {
        petType: {
          name: "",
          id: "",
        },
        petHairType: {
          name: "",
          id: "",
        },
        petClass: {},
        petWeight: "",
        petId: "",
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.drawerStatus = true;
      this.getDataList();
    });
    this.getPetType();
  },
  watch:{
  },
  methods: {
    // 洗澡美容
    changeConfig() {
      console.log("失去焦点");
      if (this.createBath.xzProjectId) {
        this.configState = true;
      }else{
        this.configState = false;
      }
      if (this.createBath.mrProjectId) {
        this.configStateXz = true;
      }else{
        this.configStateXz = false;
      }
      // 
    },
    // 确认
    submit() {
      if (this.$public.isNull(this.userId)) {
        this.$message({
          message: "请输入用户信息",
          type: "error",
        });
        return;
      }
      let shopInfo = {
        shopId: this.$store.state.shopId,
        shopName: this.$public.getShopNameById(this.$store.state.shopId),
      };
      if (this.userId) {
        let index = this.vipList.findIndex((a) => {
          return a._id == this.userId;
        });
        if (index > -1) {
          this.linkmanName = this.vipList[index].basic_info.nick_name;
          this.linkmanMobile = this.vipList[index].basic_info.user_mobile;
        }
      }
      if (this.activeName == "1") {
        if (this.$public.isNull(this.userId)) {
          this.$message({
            message: "请输入用户信息",
            type: "error",
          });
          return;
        }
        if (this.$public.isNull(this.createBath.petId)) {
          this.$message({
            message: "请输入宠物信息",
            type: "error",
          });
          return;
        }

        if (this.$public.isNull(this.createBath.reserveDate)) {
          this.$message({
            message: "请输入选择预约日期",
            type: "error",
          });
          return;
        }
        if (this.$public.isNull(this.createBath.staffId)) {
          this.$message({
            message: "请选择洗美人员",
            type: "error",
          });
          return;
        }
        if (this.$public.isNull(this.createBath.times)) {
          this.$message({
            message: "请选择洗美时间",
            type: "error",
          });
          return;
        }
        this.createBath.time = this.createBath.times[0];
        // console.log('this.createBath.time',this.createBath.time);
        if (this.createBath.time % 1 == 0) {
          // console.log('能整除');
          this.createBath.time = this.createBath.time + ":00";
        } else {
          // console.log('不能整除');
          this.createBath.time = parseInt(this.createBath.time) + ":30";
        }
        // 新建洗美
        let index = this.petsList.findIndex(
          (a) => a._id == this.createBath.petId
        );
        // console.log("index", index);
        this.reservePetInfo.petType = {
          name: this.petsList[index].apply_type.title,
          id: this.petsList[index].apply_type.value,
        };
        this.reservePetInfo.petHairType = this.petsList[index].hairLengthType;
        this.reservePetInfo.petClass = this.petsList[index].category_info;
        this.reservePetInfo.petWeight = this.petsList[index].weight;
        this.reservePetInfo.petId = this.createBath.petId;
        if (this.createBath.xzProjectId) {
          let xzNum = this.xzProjects.findIndex(
            (a) => a.id == this.createBath.xzProjectId
          );
          if (xzNum > -1) {
            let obj = {
              projectType: this.xzProjects[xzNum].projectType,
              projectId: this.createBath.xzProjectId,
              projectName: this.xzProjects[xzNum].projectName,
              coverImg: this.xzProjects[xzNum].coverImg,
              duration: this.createBath.times.length * 30,
            };
            this.projects.push(obj);
          }
        }
        if (this.createBath.mrProjectId) {
          let mrNum = this.mrProjects.findIndex(
            (a) => a.id == this.createBath.mrProjectId
          );
          if (mrNum > -1) {
            let obj = {
              projectType: this.mrProjects[mrNum].projectType,
              projectId: this.createBath.mrProjectId,
              projectName: this.mrProjects[mrNum].projectName,
              coverImg: this.mrProjects[mrNum].coverImg,
              duration: this.createBath.times.length * 30,
            };
            this.projects.push(obj);
          }
          // console.log("mrNum", mrNum);
        }
        if (this.createBath.dxProjectId.length) {
          this.createBath.dxProjectId.forEach((a) => {
            let dxNum = this.dxProjects.findIndex((b) => b.id == a);
            if (dxNum > -1) {
              let obj = {
                projectId: a,
                projectType: this.dxProjects[dxNum].projectType,
                projectName: this.dxProjects[dxNum].projectName,
                coverImg: this.dxProjects[dxNum].coverImg,
                duration: 0,
              };
              this.projects.push(obj);
            }
          });
        }
        let params = {
          userId: this.userId,
          shopInfo: shopInfo,
          remark: this.createBath.remark,
          reserveDate: this.createBath.reserveDate + " " + this.createBath.time,
          times: this.createBath.times,
          reservePetInfo: this.reservePetInfo,
          staffId: this.createBath.staffId,
          staffName: this.staffList[this.staffNum].staffName,
          staffPosition: this.staffList[this.staffNum].staffPosition,
          projects: this.projects,
          linkmanName: this.linkmanName,
          linkmanMobile: this.linkmanMobile,
        };
        console.log("params洗美", params);
        let loading = this.$loading();
        this.$http
          .post(
            process.env.VUE_APP_AppAdmin + "/api/Resvere/CreateBathing",
            params
          )
          .then((res) => {
            loading.close();
            if (res.code == 0) {
              this.drawerStatus = false;
              // console.log('添加洗美',res);
              this.$message({
                showClose: true,
                message: "添加成功",
                type: "success",
              });
            }
          });
      } else if (this.activeName == "4") {
        if (this.$public.isNull(this.seePet.petClassId)) {
          this.$message({
            message: "请选择宠物品种",
            type: "error",
          });
          return;
        }

        if (this.$public.isNull(this.seePet.reserveDate)) {
          this.$message({
            message: "请选择洗美日期",
            type: "error",
          });
          return;
        }
        if (this.$public.isNull(this.seePet.time)) {
          this.$message({
            message: "请选择洗美时间",
            type: "error",
          });
          return;
        }
        if (this.seePet.petType) {
          let index = this.seePetTypeList.findIndex(
            (a) => a.id == this.seePet.petType
          );
          if (index > -1) {
            this.seePet.petTypeObj = this.seePetTypeList[index];
          }
        }
        if (this.seePet.petClassId) {
          let index = this.petTypeList.findIndex(
            (a) => a._id == this.seePet.petClassId
          );
          if (index > -1) {
            this.seePet.petClass = {
              name: this.petTypeList[index].name,
              id: this.petTypeList[index]._id,
            };
          }
        }
        //新建看宠
        let params = {
          userId: this.userId,
          shopInfo: shopInfo,
          remark: this.seePet.remark,
          petType: this.seePet.petTypeObj,
          petClass: this.seePet.petClass,
          reserveDate: this.seePet.reserveDate + " " + this.seePet.time,
          linkmanName: this.linkmanName,
          linkmanMobile: this.linkmanMobile,
        };
        console.log("params看宠", params);
        let loading = this.$loading();
        this.$http
          .post(
            process.env.VUE_APP_AppAdmin + "/api/Resvere/CreateSeePet",
            params
          )
          .then((res) => {
            loading.close();
            if (res.code == 0) {
              // console.log('添加看宠',res);
              this.drawerStatus = false;
              this.$message({
                showClose: true,
                message: "添加成功",
                type: "success",
              });
              this.drawerStatus = false;
            }
          });
      } else if (this.activeName == "2") {
        // 医疗
        if (this.$public.isNull(this.createMedical.id)) {
          this.$message({
            message: "请选择意向服务",
            type: "error",
          });
          return;
        }

        if (this.createMedical.id) {
          let index = this.medicalProList.findIndex((a) => {
            return a.id == this.createMedical.id;
          });
          if (index > -1) {
            this.medicalPro = this.medicalProList[index];
          }
        }

        if (this.$public.isNull(this.createMedical.reserveDate)) {
          this.$message({
            message: "请选择预约日期",
            type: "error",
          });
          return;
        }
        //新建医疗
        let params = {
          shopInfo: shopInfo,
          userId: this.userId,
          remark: this.createMedical.remark,
          reserveDate:
            this.createMedical.reserveDate + " " + this.createMedical.time,
          times: this.createMedical.time,
          medicalPro: this.medicalPro,
          petId: this.createMedical.petId,
          linkmanName: this.linkmanName,
          linkmanMobile: this.linkmanMobile,
        };
        console.log("params医疗", params);
        let loading = this.$loading();
        this.$http
          .post(
            process.env.VUE_APP_AppAdmin + "/api/Resvere/CreateMedical",
            params
          )
          .then((res) => {
            loading.close();
            if (res.code == 0) {
              console.log("添加医疗", res);
              this.drawerStatus = false;
              this.$message({
                showClose: true,
                message: "添加成功",
                type: "success",
              });
            }
          });
      } else if (this.activeName == "3") {
        if (this.$public.isNull(this.userId)) {
          this.$message({
            message: "请输入用户信息",
            type: "error",
          });
          return;
        }
        if (this.$public.isNull(this.createFoster.petIds)) {
          this.$message({
            message: "请选择宠物",
            type: "error",
          });
          return;
        }

        if (this.$public.isNull(this.createFoster.reserveDate)) {
          this.$message({
            message: "请选择预约日期",
            type: "error",
          });
          return;
        }
        if (this.$public.isNull(this.createFoster.time)) {
          this.$message({
            message: "请选择预约时间",
            type: "error",
          });
          return;
        }
        //新建寄养
        let params = {
          shopInfo: shopInfo,
          userId: this.userId,
          linkmanName: this.linkmanName,
          linkmanMobile: this.linkmanMobile,
          remark: this.createFoster.remark,
          reserveDate:
            this.createFoster.reserveDate + " " + this.createFoster.time,
          petIds: this.createFoster.petIds,
        };
        console.log("params寄养", params);
        let loading = this.$loading();
        this.$http
          .post(
            process.env.VUE_APP_AppAdmin + "/api/Resvere/CreateFoster",
            params
          )
          .then((res) => {
            loading.close();
            if (res.code == 0) {
              this.drawerStatus = false;
              console.log("添加寄养", res);
              this.$message({
                showClose: true,
                message: "添加成功",
                type: "success",
              });
            }
          });
      }
    },
    // 看宠
    changeSeePet(a) {
      if (a == 3) {
        this.seePet.seeShow = false;
      } else {
        this.seePet.seeShow = true;
        this.getPetType();
      }
    },
    // 根据宠物类型获取宠物品种
    getPetType() {
      let params = {
        applyType: this.seePet.petType,
      };
      let loading = this.$loading();
      this.$http
        .get(process.env.VUE_APP_Url2 + "api/product/pet/Breed/list", params)
        .then((res) => {
          loading.close();
          // console.log("列表", res.data);
          this.petTypeList = res.data;
        });
    },
    // 选择宠物
    changePet(callback) {
      if (callback == false && this.createBath.petId) {
        // 获取宠物类型
        this.petsList.forEach((item) => {
          if (item._id == this.createBath.petId) {
            this.petClass = parseInt(item.apply_type.value);
            this.getXZConfigList();
            this.getMRConfigList();
            this.getDXConfigList();
          }
        });
        // console.log("index", index);
      }
    },
    // 获取洗美// projectType 1 洗澡 2美容 3 单项服务
    getXZConfigList() {
      let params = {
        projectType: 1,
        petType: this.petClass,
        pageIndex: 1,
        pageSize: 20,
        keyWord: "",
        shopId: this.$store.state.shopId,
        state: 1, // 0全部 1 启用 2禁用
      };
      let loading = this.$loading();
      this.$http
        .post(
          process.env.VUE_APP_AppAdmin + "/api/Resvere/GetConfigList",
          params
        )
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            this.xzProjects = res.data.list;
          }
        });
    },
    // 获取美容
    getMRConfigList() {
      let params = {
        projectType: 2,
        petType: this.petClass,
        pageIndex: 1,
        pageSize: 20,
        keyWord: "",
        shopId: this.$store.state.shopId,
        state: 1, // 0全部 1 启用 2禁用
      };
      let loading = this.$loading();
      this.$http
        .post(
          process.env.VUE_APP_AppAdmin + "/api/Resvere/GetConfigList",
          params
        )
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            this.mrProjects = res.data.list;
          }
        });
    },
    // 获取单项
    getDXConfigList() {
      let params = {
        projectType: 3,
        petType: this.petClass,
        pageIndex: 1,
        pageSize: 20,
        keyWord: "",
        shopId: this.$store.state.shopId,
        state: 1, // 0全部 1 启用 2禁用
      };
      let loading = this.$loading();
      this.$http
        .post(
          process.env.VUE_APP_AppAdmin + "/api/Resvere/GetConfigList",
          params
        )
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            this.dxProjects = res.data.list;
          }
        });
    },
    // 判断时间只能连续选择
    changeTime(callback) {
      // console.log("callback", callback);
      if (callback == false && this.createBath.times.length > 0) {
        console.log("this.createBath.times111", this.createBath.times);
        var arr = [];
        arr = this.createBath.times.map((a) => {
          return a * 10;
        });
        arr.sort((a, b) => {
          return a - b;
        });
        for (var i = 0; i < arr.length - 1; i++) {
          let num = arr[i + 1] - arr[i];
          if (num > 5) {
            this.$message.error("请选择连续的时间段");
            this.createBath.times = [];
            return;
          }
        }
      }
    },
    // 选择洗美人员显示时间
    changeBathStaff() {
      this.createBath.times=[];
      if (this.createBath.staffId) {
        let index = this.staffList.findIndex(
          (v) => v.staffId == this.createBath.staffId
        );
        this.staffNum = index;
        this.timeUseList = this.staffList[index].timeUseList;
        // console.log("timeUseList", this.timeUseList);
      }
    },
    // 获取用户宠物列表
    changeMember() {
      // console.log(1111);
      if (this.userId) {
        this.getPetListData();
      }
    },
    // 失去焦点/改变选择洗美日期
    changeBathDate() {
      this.createBath.staffId='';
      this.createBath.times=[];
      if (this.createBath.reserveDate) {
        this.getResvereTimeByDay();
      }
    },
    // 获取空闲员工时间表
    getResvereTimeByDay() {
      let params = {
        day: this.createBath.reserveDate,
        shopId: this.$store.state.shopId,
      };
      this.$http
        .get(
          process.env.VUE_APP_AppAdmin + "/api/Resvere/GetResvereTimeByDay",
          params
        )
        .then((res) => {
          if (res.code == 0) {
            this.staffList = res.data;
            console.log("res 员工", this.staffList);
          }
        });
    },
    //返回最近七天的日期
    getDataList() {
      let days = [];
      let data = new Date();
      for (let i = 0; i <= 24 * 6; i += 24) {
        //今天加上后6天
        let dateItem = new Date(data.getTime() + i * 60 * 60 * 1000); //使用当天时间戳加上以前的时间毫秒（小时*分*秒*毫秒）
        let y = dateItem.getFullYear(); //获取年份
        let m = dateItem.getMonth() + 1; //获取月份js月份从0开始，需要+1
        let d = dateItem.getDate(); //获取日期
        m = this.addDate0(m); //给为单数的月份补零
        d = this.addDate0(d); //给为单数的日期补零
        let valueItem = y + "-" + m + "-" + d; //组合
        days.push(valueItem); //添加至数组
      }
      // console.log("最近七天日期：", days);
      this.days = days;
    },

    //给日期加0
    addDate0(time) {
      if (time.toString().length == 1) {
        time = "0" + time.toString();
      }
      return time;
    },

    //获取宠物列表
    getPetListData() {
      let params = {
        id: this.userId,
      };
      this.$http
        .get(process.env.VUE_APP_Url7 + "api/middleware/Pet/List", params)
        .then((res) => {
          if (res.code == 0) {
            console.log("宠物列表", res.data);
            this.petsList = res.data;
          }
        });
    },
    //获取会员信息列表
    remoteMethodMember(str) {
      this.$util.getVipList(str).then((list) => {
        this.vipList = list;
      });
    },

    // tab切换
    handleClick(tab, event) {
      this.userId = "";
      console.log(tab, event);
    },
    //   关闭弹框
    handleClose() {
      this.$emit("submit");
    },
  },
  //
};
</script>

<style scoped lang="scss">
.page {
  padding: 20px;
  font-size: 14px;
  ::v-deep .el-tabs__item.is-active {
    color: #f5882a;
  }
  ::v-deep .el-tabs__active-bar {
    background-color: #f5882a;
  }
  ::v-deep .el-input__inner {
    width: 200px;
  }
  .btnBox {
    width: 100%;
    font-size: 14px;
    color: #fff;
    line-height: 40px;
    display: flex;
    position: absolute;
    bottom: 0;
    z-index: 10;
    .btnItem {
      text-align: center;
      width: 100%;
      background-color: #d6d6d6;
      cursor: pointer;
      &.submit {
        background-color: $mainColor;
      }
    }
  }
}
</style>